import React, { Component } from "react";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import { connect } from "react-redux";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    MenuItem,
    Select,
    IconButton,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import {
    selectReport,
    canUpdate,
    selectUserNames,
    selectVehicles,
    selectEquipment,
} from "./selectors";
import PrintIcon from "@material-ui/icons/Print";
import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    getReport,
    getStandaloneReport,
    setReport,
    getVehicles,
    getEquipment,
} from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";
import MapWrapper from "./Components/MapContainer/MapWrapper";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ReactToPrint from "react-to-print";
import "../reports.css";
import styled from "styled-components";
import moment from "moment";
import { Remove as RemoveIcon, Add as AddIcon } from "@material-ui/icons";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class DailyWorksheet extends Component {
    constructor(props) {
        super(props);
        let edit = props.location.pathname.split("/");
        checkedit = edit[1];
        props.getEquipment();
        props.getVehicles();
        if (props.match.params.subject_name === "reports") {
            this.state = {
                imageModal: false,
                report: false,
                editing:
                    edit[1] === "report-view"
                        ? false
                        : edit[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
                selectedPhoto: false,
                selectedVehicle: "",
                selectedEquipment: "",
                selectedUser: "",
            };
            props.getStandaloneReport(
                props.match.params.uprn,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        } else {
            this.state = {
                imageModal: false,
                report: false,
                editing:
                    edit[1] === "report-view"
                        ? false
                        : edit[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
                selectedPhoto: false,
                selectedVehicle: "",
                selectedEquipment: "",
            };

            props.getReport(
                props.match.params.uprn,
                props.match.params.subject_name.replace(/-/g, "_"),
                edit[3],
                edit[4].replace(/-/g, "_"),
                edit[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        console.log(prevProps,"prevprops")
        console.log(this.props.report,"this.props.report")
        if (this.props.report !== prevProps.report) {
            console.log("entering hee")
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value, isArr, index, parentKey) => {
        if (this.state.editing) {
            return (
                <TextField
                    style={{ width: "100%" }}
                    value={this.state.report[key]}
                    onChange={(event) => {
                        if (isArr) {
                            let arr = this.state.report[parentKey];
                            arr[index][key] = event.target.value;
                            let report = {
                                ...this.state.report,
                                [parentKey]: arr,
                            };
                            this.setState({ report });
                        } else {
                            let report = {
                                ...this.state.report,
                                [key]: event.target.value,
                            };
                            this.setState({ report });
                        }
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    style={{ width: "100%" }}
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };
    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url;
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:") ? (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: sig.signature_url,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: ref,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        let report = this.state.report === false ? false : this.state.report;
        let rT = this.renderText;
        let dp = this.renderDropDown;
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let RCount = 2;
        let SumCount = 2;
        let pCount = 1;
        let sCount = 1;
        let eCount = 1;
        let color = this.props.color;
        return this.state.editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Daily Worksheet Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Daily Worksheet
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    "Daily Worksheet - " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%" }}>
                                <div style={{ width: "65%", float: "left" }}>
                                    <div
                                        style={gstyle(5, 13, null, color)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Job Details</b>
                                        </div>

                                        <div style={cstyle(2, 1, 2, 8)}>
                                            <b>Job ID:</b>&nbsp;{report.job_id}
                                        </div>
                                        <div style={cstyle(2, 8, 2, 13)}>
                                            <b>Job Name:</b>&nbsp;
                                            {report.job_name}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 8)}>
                                            <b>Job Type: </b>&nbsp;
                                            {report.job_type}
                                        </div>
                                        <div style={cstyle(3, 8, 3, 13)}>
                                            <b>Form Created: </b>&nbsp;
                                            {report.timestamp}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 13)}>
                                            <b>Job Address:</b>&nbsp;
                                            {report.job_address}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 8)}>
                                            <b>Job Date:</b>&nbsp;
                                            {report.job_date}
                                        </div>
                                        <div style={cstyle(6, 8, 6, 13)}>
                                            <b>Job Stage: </b>&nbsp;&nbsp;
                                            {dp("job_stage", report.job_stage, [
                                                "Planning",
                                                "Preparation",
                                                "Pre-Works",
                                                "Works",
                                                "Aftercare",
                                                "Inspection & Monitoring",
                                                "Complete",
                                            ])}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 8)}>
                                            <b>User Name: </b>&nbsp;
                                            {report.user_name}
                                        </div>
                                        <div style={cstyle(7, 8, 7, 13)}>
                                            <b>User Email: </b>&nbsp;{" "}
                                            {report.user_email}
                                        </div>
                                        <div style={cstyle(8, 1, 8, 8)}>
                                            <b>Start Time: </b>&nbsp;
                                            {report.travel_time_start}
                                        </div>
                                        <div style={cstyle(8, 8, 8, 13)}>
                                            <b>End Time: </b>&nbsp;
                                            {report.travel_time_end}
                                        </div>
                                        <div style={cstyle(9, 1, 9, 8)}>
                                            <b>Weather: </b>&nbsp;
                                            {dp(
                                                "site_weather",
                                                report.site_weather,
                                                [
                                                    "Hot Weather (>20C)",
                                                    "Sunny or Clear Sky",
                                                    "Cloudy",
                                                    "Fog",
                                                    "Light/Intermittent Rain Showers",
                                                    "Sleet",
                                                    "Snow",
                                                    "Heavy or Persistent Rain",
                                                    "Storm",
                                                    "Thunderstorm",
                                                ]
                                            )}
                                        </div>
                                        <div style={cstyle(9, 8, 9, 13)}>
                                            <b>Lighting: </b>&nbsp;
                                            {dp(
                                                "site_lighting",
                                                report.site_lighting,
                                                [
                                                    "Day",
                                                    " Sun Low in the horizon",
                                                    "Night and Lit Area",
                                                    "Night and Unlit Area",
                                                ]
                                            )}
                                        </div>
                                        <div style={cstyle(10, 1, 10, 8)}>
                                            <b>Visibility: </b>&nbsp;
                                            {dp(
                                                "site_visibility",
                                                report.site_visibility,
                                                [
                                                    "Good Visibility",
                                                    " Reduced Visibility (<215m)",
                                                    "Poor Visibility (<100m)",
                                                ]
                                            )}
                                        </div>
                                        <div style={cstyle(10, 8, 10, 13)}>
                                            <b>Surface Conditions: </b>&nbsp;
                                            {dp(
                                                "site_surface",
                                                report.site_surface,
                                                [
                                                    "Dry",
                                                    "Damp",
                                                    "Wet",
                                                    "Standing Water",
                                                    "Flooding",
                                                    "Muck or Dirt",
                                                    "Ice",
                                                    "Snow",
                                                    "Treated with winter service",
                                                ]
                                            )}
                                        </div>
                                        <div style={cstyle(11, 1, 11, 13)}>
                                            <b>Contract Number: </b>&nbsp;
                                            {report.contract_number}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        float: "left",
                                        marginLeft: "2%",
                                        width: "32%",

                                        height:
                                            this.infoDiv === undefined
                                                ? 0
                                                : this.infoDiv.offsetHeight -
                                                  10,
                                    }}
                                >
                                    <MapWrapper
                                        start={report.start_location}
                                        end={report.end_location}
                                        waypoints={report.waypoints}
                                    />
                                </div>
                            </div>

                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Plant On Site:</b>
                                    </div>

                                    {report.plant_on_site &&
                                        report.plant_on_site.map((f, i) => {
                                            pCount++;

                                            return (
                                                <React.Fragment key={pCount}>
                                                    <div
                                                        style={cellStyle(
                                                            pCount,
                                                            1,
                                                            pCount,
                                                            5
                                                        )}
                                                    >
                                                        {f}
                                                        {this.state.editing && (
                                                            <IconButton
                                                                style={{
                                                                    float:
                                                                        "right",
                                                                    background:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    let arr = this
                                                                        .state
                                                                        .report
                                                                        .plant_on_site;
                                                                    if (
                                                                        arr.length >
                                                                        1
                                                                    )
                                                                        arr.splice(
                                                                            1,
                                                                            i
                                                                        );
                                                                    else
                                                                        arr = [];

                                                                    let report = {
                                                                        ...this
                                                                            .state
                                                                            .report,
                                                                        plant_on_site: arr,
                                                                    };
                                                                    this.setState(
                                                                        {
                                                                            report,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <RemoveIcon />
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                {this.state.editing && (
                                    <Select
                                        style={{ width: "30%" }}
                                        placeholder="Select Vehicle"
                                        value={this.state.selectedVehicle || ""}
                                        onChange={(event) => {
                                            this.setState({
                                                selectedVehicle:
                                                    event.target.value,
                                            });
                                        }}
                                    >
                                        {this.props.vehicles &&
                                            Object.keys(
                                                this.props.vehicles
                                            ).map((option) => {
                                                const {
                                                    profile: {
                                                        machine_desc = "N/A",
                                                        machine_reg = "N/A",
                                                    },
                                                } = this.props.vehicles[option];
                                                return (
                                                    <MenuItem
                                                        value={
                                                            machine_desc +
                                                            " - " +
                                                            machine_reg
                                                        }
                                                        key={option}
                                                    >
                                                        {machine_desc +
                                                            " - " +
                                                            machine_reg}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                )}
                                {this.state.editing && (
                                    <IconButton
                                        style={{
                                            background: "#0188cc",
                                            margin: 12,
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let arr =
                                                this.state.report
                                                    .plant_on_site || [];
                                            arr.push(
                                                this.state.selectedVehicle
                                            );
                                            let report = {
                                                ...this.state.report,
                                                plant_on_site: arr,
                                            };
                                            this.setState({ report });
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                )}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Extra Plant:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 3)}>
                                        <b>Extra Plant:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2, true)}>
                                        {rT("extra_plant", report.extra_plant)}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Equipment On Site:</b>
                                    </div>

                                    {report.equipment_on_site &&
                                        report.equipment_on_site.map((f, i) => {
                                            eCount++;

                                            return (
                                                <React.Fragment key={eCount}>
                                                    <div
                                                        style={cellStyle(
                                                            eCount,
                                                            1,
                                                            eCount,
                                                            5
                                                        )}
                                                    >
                                                        {f}
                                                        {this.state.editing && (
                                                            <IconButton
                                                                style={{
                                                                    float:
                                                                        "right",
                                                                    background:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    let arr = this
                                                                        .state
                                                                        .report
                                                                        .equipment_on_site;
                                                                    if (
                                                                        arr.length >
                                                                        1
                                                                    )
                                                                        arr.splice(
                                                                            1,
                                                                            i
                                                                        );
                                                                    else
                                                                        arr = [];

                                                                    let report = {
                                                                        ...this
                                                                            .state
                                                                            .report,
                                                                        equipment_on_site: arr,
                                                                    };
                                                                    this.setState(
                                                                        {
                                                                            report,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <RemoveIcon />
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                {this.state.editing && (
                                    <Select
                                        style={{ width: "30%" }}
                                        value={
                                            this.state.selectedEquipment || ""
                                        }
                                        placeholder="Select Equipment"
                                        onChange={(event) => {
                                            this.setState({
                                                selectedEquipment:
                                                    event.target.value,
                                            });
                                        }}
                                    >
                                        {this.props.equipment &&
                                            Object.keys(
                                                this.props.equipment
                                            ).map((option) => {
                                                const {
                                                    profile: { name = "N/A" },
                                                } = this.props.equipment[
                                                    option
                                                ];
                                                return (
                                                    <MenuItem
                                                        value={name}
                                                        key={option}
                                                    >
                                                        {name}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                )}
                                {this.state.editing && (
                                    <IconButton
                                        style={{
                                            background: "#0188cc",
                                            margin: 12,
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let arr =
                                                this.state.report
                                                    .equipment_on_site || [];
                                            arr.push(
                                                this.state.selectedEquipment
                                            );
                                            let report = {
                                                ...this.state.report,
                                                equipment_on_site: arr,
                                            };
                                            this.setState({ report });
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                )}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Extra Equipment:</b>
                                    </div>

                                    <div style={cstyle(2, 1, 2, 2, true)}>
                                        {rT(
                                            "extra_equipment",
                                            report.extra_equipment
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Staff On Site:</b>
                                    </div>

                                    {report.staff_on_site &&
                                        report.staff_on_site.map((f, i) => {
                                            sCount++;

                                            return (
                                                <React.Fragment key={sCount}>
                                                    <div
                                                        style={cellStyle(
                                                            sCount,
                                                            1,
                                                            sCount,
                                                            5
                                                        )}
                                                    >
                                                        {f}
                                                        {this.state.editing && (
                                                            <IconButton
                                                                style={{
                                                                    float:
                                                                        "right",
                                                                    background:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    let arr = this
                                                                        .state
                                                                        .report
                                                                        .staff_on_site;
                                                                    if (
                                                                        arr.length >
                                                                        1
                                                                    )
                                                                        arr.splice(
                                                                            1,
                                                                            i
                                                                        );
                                                                    else {
                                                                        arr = [];
                                                                    }
                                                                    let report = {
                                                                        ...this
                                                                            .state
                                                                            .report,
                                                                        staff_on_site: arr,
                                                                    };
                                                                    this.setState(
                                                                        {
                                                                            report,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <RemoveIcon />
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                {this.state.editing && (
                                    <Select
                                        style={{ width: "30%" }}
                                        value={this.state.selectedUser || ""}
                                        placeholder="Select User"
                                        onChange={(event) => {
                                            this.setState({
                                                selectedUser:
                                                    event.target.value,
                                            });
                                        }}
                                    >
                                        {this.props.users &&
                                            this.props.users.map((option) => {
                                                return (
                                                    <MenuItem
                                                        value={option}
                                                        key={option}
                                                    >
                                                        {option}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                )}
                                {this.state.editing && (
                                    <IconButton
                                        style={{
                                            background: "#0188cc",
                                            margin: 12,
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let arr =
                                                this.state.report
                                                    .staff_on_site || [];
                                            arr.push(this.state.selectedUser);
                                            let report = {
                                                ...this.state.report,
                                                staff_on_site: arr,
                                            };
                                            this.setState({ report });
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                )}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Extra staff Members:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 3)}>
                                        <b>Extra Staff Members:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2, true)}>
                                        {rT("extra_staff", report.extra_staff)}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Materials On Site:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 3)}>
                                        <b>Material:</b>
                                    </div>
                                    <div style={cstyle(2, 3, 2, 3)}>
                                        <b>Supplier:</b>
                                    </div>

                                    <div style={cstyle(2, 4, 2, 4)}>
                                        <b>Units:</b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 5)}>
                                        <b>Amount:</b>
                                    </div>

                                    {report.materials_on_site &&
                                        report.materials_on_site.map((f, i) => {
                                            RCount++;

                                            return (
                                                <React.Fragment key={RCount}>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            1,
                                                            RCount,
                                                            3
                                                        )}
                                                    >
                                                        {rT(
                                                            "material",
                                                            f.material,
                                                            true,
                                                            i,
                                                            "materials_on_site"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            3,
                                                            RCount,
                                                            3
                                                        )}
                                                    >
                                                        {rT(
                                                            "supplier",
                                                            f.supplier,
                                                            true,
                                                            i,
                                                            "materials_on_site"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            4,
                                                            RCount,
                                                            4,
                                                            true
                                                        )}
                                                    >
                                                        {rT(
                                                            "unit",
                                                            f.unit,
                                                            true,
                                                            i,
                                                            "materials_on_site"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            5,
                                                            RCount,
                                                            5
                                                        )}
                                                    >
                                                        {rT(
                                                            "amount",
                                                            f.amount,
                                                            true,
                                                            i,
                                                            "materials_on_site"
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                {this.state.editing && (
                                    <Button
                                        style={{
                                            background: "#0188cc",
                                            margin: 12,
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let arr =
                                                this.state.report
                                                    .materials_on_site || [];
                                            arr.push({
                                                amount: "",
                                                material: "",
                                                supplier: "",
                                                unit: "",
                                            });
                                            let report = {
                                                ...this.state.report,
                                                materials_on_site: arr,
                                            };

                                            this.setState({ report });
                                        }}
                                    >
                                        Add Material
                                    </Button>
                                )}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Waste Details:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 3)}>
                                        <b>Waste Disposal Location:</b>&nbsp;  {rT(
                                            "waste_disposal_location",
                                            report.waste_disposal_location
                                        )}
                                    </div>
                              
                                    <div style={cstyle(2, 3, 2, 5)}>
                                        <b>Waste Quantity:</b>&nbsp;   {rT(
                                            "waste_quantity",
                                            report.waste_quantity
                                        )}
                                    </div>
                              

                                    <div style={cstyle(3, 1, 3, 5)}>
                                        <b>Waste Description:</b>&nbsp;  {rT(
                                            "waste_description",
                                            report.waste_description
                                        )}
                                    </div>
                                 
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 4, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Notes/Description</b>
                                    </div>

                                    <div style={cstyle(2, 1, 5, 5, true)}>
                                        {rT(
                                            "work_description",
                                            report.work_description
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 8, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Job Lots</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2)}>
                                        <b>Job Created:</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 3)}>
                                        <b>Job Finished:</b>
                                    </div>

                                    <div style={cstyle(2, 3, 2, 4)}>
                                        <b>Before Image:</b>
                                    </div>
                                    <div style={cstyle(2, 4, 2, 5)}>
                                        <b>After Image:</b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 6)}>
                                        <b>Description:</b>
                                    </div>
                                    <div style={cstyle(2, 6, 2, 7)}>
                                        <b>Unit Count:</b>
                                    </div>
                                    <div style={cstyle(2, 7, 2, 8)}>
                                        <b>Unit Metric:</b>
                                    </div>
                                    <div style={cstyle(2, 8, 2, 9)}>
                                        <b>Map Location:</b>
                                    </div>
                                    {report.job_lots &&
                                        report.job_lots.map((f, i) => {
                                            RCount++;

                                            return (
                                                <React.Fragment key={RCount}>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            1,
                                                            RCount,
                                                            2
                                                        )}
                                                    >
                                                        {f.created_timestamp}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            2,
                                                            RCount,
                                                            3
                                                        )}
                                                    >
                                                        {f.finished_timestamp}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            3,
                                                            RCount,
                                                            4,
                                                            true
                                                        )}
                                                    >
                                                        {f.before_photo && (
                                                            <img
                                                                src={
                                                                    f
                                                                        .before_photo
                                                                        .photo_url
                                                                }
                                                                alt="Site "
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            selectedPhoto:
                                                                                f.before_photo,
                                                                            imageModal: true,
                                                                        }
                                                                    );
                                                                }}
                                                                style={{
                                                                    width:
                                                                        "auto",
                                                                    height:
                                                                        "90px",
                                                                    margin:
                                                                        "auto",
                                                                    cursor:
                                                                        "pointer",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            4,
                                                            RCount,
                                                            5
                                                        )}
                                                    >
                                                        {f.after_photo && (
                                                            <img
                                                                src={
                                                                    f
                                                                        .after_photo
                                                                        .photo_url
                                                                }
                                                                alt="Site "
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            selectedPhoto:
                                                                                f.after_photo,
                                                                            imageModal: true,
                                                                        }
                                                                    );
                                                                }}
                                                                style={{
                                                                    width:
                                                                        "auto",
                                                                    height:
                                                                        "90px",
                                                                    margin:
                                                                        "auto",
                                                                    cursor:
                                                                        "pointer",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            5,
                                                            RCount,
                                                            6
                                                        )}
                                                    >
                                                        {rT(
                                                            "description",
                                                            f.description,
                                                            true,
                                                            i,
                                                            "job_lots"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            6,
                                                            RCount,
                                                            7
                                                        )}
                                                    >
                                                        {rT(
                                                            "unit_count",
                                                            f.unit_count,
                                                            true,
                                                            i,
                                                            "job_lots"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            7,
                                                            RCount,
                                                            8
                                                        )}
                                                    >
                                                        {rT(
                                                            "unit_metric",
                                                            f.unit_metric,
                                                            true,
                                                            i,
                                                            "job_lots"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            8,
                                                            RCount,
                                                            9
                                                        )}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                pageBreakInside:
                                                                    "avoid",
                                                                height: "auto",
                                                            }}
                                                        >
                                                            {f.location_lat &&
                                                                f.location_lon && (
                                                                    <img
                                                                        style={{
                                                                            width:
                                                                                "130px",
                                                                            marginTop:
                                                                                "12px",
                                                                        }}
                                                                        alt="static map"
                                                                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${f.location_lat},${f.location_lon}&zoom=16&size=300x150&maptype=roadmap&markers=color:red%7C${f.location_lat},${f.location_lon}&key=AIzaSyD489nheoQV_OPuhsC9yDkuqe7wmiW-1R8`}
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                {this.state.editing && (
                                    <Button
                                        style={{
                                            background: "#0188cc",
                                            margin: 12,
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let arr =
                                                this.state.report.job_lots ||
                                                [];
                                            arr.push({
                                                created_timestamp: moment().format(
                                                    "DD-MM-YY HH:mm:ss"
                                                ),
                                                before_photo: {
                                                    photo_name: "",
                                                    photo_timestamp: "",
                                                    photo_url: "",
                                                },
                                                description: "",
                                                id: arr.length + 1,
                                                location_lat: "",
                                                location_lon: "",
                                            });
                                            let report = {
                                                ...this.state.report,
                                                job_lots: arr,
                                            };

                                            this.setState({ report });
                                        }}
                                    >
                                        Add Job Lot
                                    </Button>
                                )}
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(5, 3, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 3, false, true)}
                                    >
                                        <b>Job Lots Summary</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2)}>
                                        <b>Unit Total Count:</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 3)}>
                                        <b>Unit Metric:</b>
                                    </div>

                                    {report.job_lots_summary &&
                                        Object.keys(
                                            report.job_lots_summary
                                        ).map((f) => {
                                            SumCount++;
                                            if (report.job_lots_summary[f] > 0)
                                                return (
                                                    <React.Fragment
                                                        key={SumCount}
                                                    >
                                                        <div
                                                            style={cellStyle(
                                                                SumCount,
                                                                1,
                                                                SumCount,
                                                                2
                                                            )}
                                                        >
                                                            {
                                                                report
                                                                    .job_lots_summary[
                                                                    f
                                                                ]
                                                            }
                                                        </div>
                                                        <div
                                                            style={cellStyle(
                                                                SumCount,
                                                                2,
                                                                SumCount,
                                                                3
                                                            )}
                                                        >
                                                            {f}
                                                        </div>
                                                    </React.Fragment>
                                                );

                                            return null;
                                        })}
                                </div>
                            </div>
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                    <b>Attached Photos</b>
                                </div>
                                {report.attached_photos &&
                                    this.renderPhotos(report.attached_photos)}
                            </div>
                            <div>
                                <br />
                                {typeof report.attached_signatures ===
                                    "undefined" ||
                                report.attached_signatures === null ? (
                                    ""
                                ) : (
                                    <h6>
                                        <CheckBoxIcon></CheckBoxIcon> I confirm
                                        the work is completed to my satisfaction
                                    </h6>
                                )}
                                <br />
                            </div>
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                    <b>Attached Signatures</b>
                                </div>
                                {report.attached_signatures &&
                                    this.renderSigs(report.attached_signatures)}
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                {this.state.editing &&
                                    checkedit === "report-edit-jobpack" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-edit-jobpack",
                                                "report-view"
                                            )}
                                        >
                                            <div>
                                                <ActionButton
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => {
                                                        this.props.setReport(
                                                            this.state.report,
                                                            this.props.location
                                                                .pathname
                                                        );
                                                        this.props.setActivity(
                                                            "update",
                                                            "report",
                                                            this.state
                                                                .reportType
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Submit
                                                </ActionButton>
                                                <ActionButton
                                                    color="secondary"
                                                    variant="contained"
                                                >
                                                    Cancel
                                                </ActionButton>
                                            </div>
                                        </Link>
                                    )}

                                {!this.state.editing &&
                                    this.props.canUpdate &&
                                    checkedit === "report-view" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-view",
                                                "report-edit-jobpack"
                                            )}
                                        >
                                            <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                            </ActionButton>
                                        </Link>
                                    )}
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                {this.state.editing &&
                                    checkedit === "report-edit" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-edit",
                                                "report-view-standalone"
                                            )}
                                        >
                                            <div>
                                                <ActionButton
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => {
                                                        this.props.setReport(
                                                            this.state.report,
                                                            this.props.location
                                                                .pathname
                                                        );
                                                        this.props.setActivity(
                                                            "update",
                                                            "report",
                                                            this.state
                                                                .reportType
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Submit
                                                </ActionButton>
                                                <ActionButton
                                                    color="secondary"
                                                    variant="contained"
                                                >
                                                    Cancel
                                                </ActionButton>
                                            </div>
                                        </Link>
                                    )}

                                {!this.state.editing &&
                                    this.props.canUpdate &&
                                    checkedit === "report-view-standalone" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-view-standalone",
                                                "report-edit"
                                            )}
                                        >
                                            <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                            </ActionButton>
                                        </Link>
                                    )}
                            </div>
                        </div>
                    )}
                    <Modal isOpen={this.state.imageModal}>
                        <ModalHeader>Image Modal</ModalHeader>
                        <ModalBody style={{ margin: "auto" }}>
                            <img
                                src={
                                    this.state.selectedPhoto.photo_url ===
                                        undefined ||
                                    this.state.selectedPhoto.photo_url ===
                                        null ||
                                    this.state.selectedPhoto.photo_url === ""
                                        ? this.state.selectedPhoto.signature_url
                                        : this.state.selectedPhoto.photo_url
                                }
                                alt="Site"
                                style={{ width: "350px", height: "350px" }}
                            />
                            <Typography>
                                <b>Timestamp:</b>{" "}
                                {this.state.selectedPhoto.photo_timestamp
                                    ? this.state.selectedPhoto.photo_timestamp
                                    : this.state.selectedPhoto
                                          .signature_timestamp}
                            </Typography>
                            <Typography>
                                <b>Name:</b>{" "}
                                {this.state.selectedPhoto.photo_name
                                    ? this.state.selectedPhoto.photo_name
                                    : this.state.selectedPhoto.signature_name}
                            </Typography>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    this.setState({ imageModal: false });
                                }}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return {
            report: selectReport(store),
            canUpdate: canUpdate(store),
            users: selectUserNames(store),
            vehicles: selectVehicles(store),
            equipment: selectEquipment(store),
        };
    },
    {
        getReport,
        getStandaloneReport,
        setActivity,
        setReport,
        getVehicles,
        getEquipment,
    }
)(DailyWorksheet);
